import { render, staticRenderFns } from "./SchemeList.vue?vue&type=template&id=64f30352&"
import script from "./SchemeList.vue?vue&type=script&lang=js&"
export * from "./SchemeList.vue?vue&type=script&lang=js&"
import style0 from "./SchemeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports